<!-- src/pages/Dashboard.vue -->
<script setup>
import { onMounted, ref } from 'vue'
import { RouterLink } from 'vue-router'
import { api } from '../api/client'

const state = ref({ loading: true, data: null, err: '' })

onMounted(async () => {
  try {
    const { data } = await api.get('/ctv/me')
    state.value = { loading: false, data, err: '' }
  } catch (e) {
    state.value = { loading: false, data: null, err: e?.response?.data?.error || 'ERR' }
  }
})

function copy(code='') {
  if (!code) return
  navigator.clipboard?.writeText(code).catch(()=>{})
}
</script>

<template>
  <div v-if="state.loading" class="main"><div class="note">Đang tải…</div></div>
  <div v-else-if="state.err" class="main"><div class="error">{{ state.err }}</div></div>

  <template v-else>
    <div v-if="!state.data?.hasCtv" class="main">
      <div class="banner">
        <h3>Bạn chưa đăng ký Cộng tác viên</h3>
        <p class="note">Đăng ký để nhận mã giới thiệu và theo dõi doanh thu.</p>
        <RouterLink class="btn btn-primary" to="/register-ctv" style="margin-top:12px">Đăng ký CTV</RouterLink>
      </div>
    </div>

    <div v-else-if="state.data.status === 'PENDING'" class="main">
      <div class="banner">
        <h3>Hồ sơ đang chờ xác nhận</h3>
        <p class="note">Chúng tôi sẽ duyệt sớm. Sau khi duyệt chúng tôi sẽ gửi email xác nhận cho bạn. Bạn có thể quay lại sau.</p>
      </div>
    </div>

    <div v-else-if="state.data.status === 'REJECTED'" class="main">
      <div class="banner">
        <h3>Hồ sơ bị từ chối</h3>
        <p class="note">Lý do: {{ state.data.reviewNote || 'Không rõ' }}</p>
      </div>
    </div>

    <div v-else-if="state.data.status === 'APPROVED_NEED_SIGN'" class="main">
      <div class="banner">
        <h3>Hồ sơ đã duyệt — Hãy ký hợp đồng ngay</h3>
        <p class="note">Sau khi ký online, tài khoản cộng tác viên của bạn sẽ tự kích hoạt.</p>
        <!-- SPA navigation -->
        <RouterLink class="btn" to="/sign" style="margin-top:12px">Ký hợp đồng</RouterLink>
      </div>
    </div>

    <!-- Mặc định coi như đã kích hoạt: hiển thị Dashboard -->
    <div v-else class="main">
      <div class="card">
        <h2>Dashboard CTV</h2>
        <div class="codebox">
          <div class="code">Mã CTV: <b>{{ state.data.ctvCode || '(đang cấp)' }}</b></div>
          <button class="btn" @click="copy(state.data.ctvCode || '')">Copy</button>
        </div>
        <p class="note" style="margin-top:12px">Thống kê sẽ hiển thị sau khi tích hợp sự kiện referral.</p>
      </div>
    </div>
  </template>
</template>
